import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { isUndefined } from 'lodash';
import {
  EMAIL_SEPARATOR,
  EmailService,
} from '../../services/email/email.service';

const insignia = require('insignia');
const ENTER_KEY = 13;

@Directive({
  selector: '[appEmailTag]',
})
export class EmailTagDirective implements OnInit, OnDestroy {
  @Input() limit: number;

  @Output() emailTag: EventEmitter<string> = new EventEmitter<string>();
  @Output() hitMaxTags: EventEmitter<boolean> = new EventEmitter<boolean>();

  private _el: any;
  private _instance: any;

  @HostListener('keydown', ['$event'])
  onKeydown(evt) {
    // Prevent typing when limit is exceeded
    const numTags = this._instance.allValues().length;

    if (!isUndefined(this.limit) && numTags >= this.limit) {
      evt.preventDefault();
      this.hitMaxTags.emit(true);
    } else {
      this.hitMaxTags.emit(false);
    }

    // Add comma as delimiter
    if (
      evt.key === ',' ||
      evt.key === ';' ||
      evt.keyCode === ENTER_KEY ||
      evt.which === ENTER_KEY
    ) {
      this._instance.refresh();
      evt.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(evt) {
    evt.stopPropagation();
    evt.preventDefault();

    const clipboardData = evt.clipboardData
      ? evt.clipboardData.getData('Text')
      : '';

    this.addEmailsToInstance(clipboardData);
  }

  constructor(
    private _elementRef: ElementRef,
    private _emailService: EmailService
  ) {}

  ngOnInit() {
    this._el = this._elementRef.nativeElement;

    setTimeout(() => {
      if (this._el) {
        const initialValue = this._el.value;

        // Reset value to add manually with multiple delimiters
        this._el.value = '';
        this._instance = insignia(this._el, {
          deletion: true,
          validate: (value: string) => this._emailService.isValidEmail(value),
        });
        this._instance.on('add', this.updateEmails.bind(this));
        this._instance.on('remove', this.updateEmails.bind(this));

        this.addEmailsToInstance(initialValue);
      }
    });
  }

  updateEmails() {
    const allEmails = this._instance.allValues();

    this.emailTag.emit(allEmails.join(EMAIL_SEPARATOR));
  }

  addEmailsToInstance(emails: string) {
    const tokenizedEmails = this._emailService.tokenizeEmails(emails);

    if (isUndefined(this.limit)) {
      tokenizedEmails.forEach((email: string) => this._instance.addItem(email));
    } else {
      const currentCount = this._instance.allValues().length;
      const newLimit = this.limit - currentCount;
      const validEmails = tokenizedEmails.slice(0, newLimit);

      // Only add if number of emails is below limit
      validEmails.forEach((email: string) => this._instance.addItem(email));
    }
  }

  ngOnDestroy() {
    if (this._instance) {
      this._instance.destroy();
    }
  }
}
